module.exports = __webpack_public_path__ + "img/content-img1_1.47d050bf.png";